export default [

  {
    path: "policy-unique-blocks",
    meta: {
      title: "proposedUniqueBlocks",
    },
    component: () => import("@/views/pages/proposedUniqueBlocks.vue"),
  },
  {
    path: "policy-unique-blocks/draftreviews",
    meta: {
      title: "proposedUniqueBlocks",
    },
    component: () => import("@/views/pages/proposedUniqueBlocks.vue"),
  },

  {
    path: "policy-unique-blocks/completed",
    meta: {
      title: "proposedUniqueBlocks",
    },
    component: () => import("@/views/pages/proposedUniqueBlocks.vue"),
  },
  {
    path: "policy-unique-blocks/deleted",
    meta: {
      title: "proposedUniqueBlocks",
    },
    component: () => import("@/views/pages/proposedUniqueBlocks.vue"),
  },

  {
    path: "policy-management",
    meta: {
      title: "policyManagement",
      target:
        process.env.VUE_APP_AGMS_URL + `/AppGuardMain/Group?$paramsByRole`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "policy-management/group",
    meta: {
      title: "policyManagementGroup",
      target:
        process.env.VUE_APP_AGMS_URL + `/AppGuardMain/Group?$paramsByRole`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "default-enclave",
    meta: {
      title: "defaultEnclave",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/Spaces?$paramsByRole&policytypeId=10`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-publishers",
    meta: {
      title: "trustedPublishers",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=4`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "power-apps",
    meta: {
      title: "powerApps",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/PowerApps?$paramsByRole&policytypeId=3`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-folders",
    meta: {
      title: "trustedFolders",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/TrustedFolders?$paramsByRole&policytypeId=14`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "global-policy",
    meta: {
      title: "globalPolicy",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/GlobalPolicy?$paramsByRole&policytypeId=12`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "code-load",
    meta: {
      title: "codeLoad",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/CodeLoad?$paramsByRole&policytypeId=13`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "netlock-policy",
    meta: {
      title: "netlockPolicy",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/NetLockPolicy?$paramsByRole&policytypeId=15`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "trusted-enclave",
    meta: {
      title: "trustedEnclave",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=7`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "removable-media",
    meta: {
      title: "removableMedia",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/$policySubmenu/RemovableMedia?$paramsByRole&policytypeId=5`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "custom-scripts",
    meta: {
      title: "customScripts",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Policy/Policy/PolicyList?$paramsByRole&policytypeId=8`,
      needMainId: true,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "publishers",
    meta: {
      title: "publishers",
      target:
        process.env.VUE_APP_AGMS_URL +
        `/Computers/Computers/LogPublishers`,
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "space-rule",
    meta: {
      title: "spaceRule",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=9",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "ignore-message",
    meta: {
      title: "ignoreMessage",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=1",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "ignore-events",
    meta: {
      title: "ignoreEvents",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/GroupPolicy/IgnoreEventsFilter?$paramsByRole&policytypeId=19",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "severity-events",
    meta: {
      title: "severityEvents",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/GroupPolicy/SeverityEventsFilter?$paramsByRole&policytypeId=20",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "ignore-events-role",
    meta: {
      title: "ignoreEvents",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/TemplatePolicy/IgnoreEventsFilter?$paramsByRole&policytypeId=19",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "severity-events-role",
    meta: {
      title: "severityEvents",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/TemplatePolicy/SeverityEventsFilter?$paramsByRole&policytypeId=20",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "file-extensions",
    meta: {
      title: "fileExtensions",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/Policy/PolicyList?$paramsByRole&policytypeId=17",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "agent-alerts",
    meta: {
      title: "agentAlerts",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/$policySubmenu/AgentAlerts?$paramsByRole&policytypeId=17",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "summary-events",
    meta: {
      title: "summaryEvents",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/Policy/$policySubmenu/SummaryEvents?$paramsByRole&policytypeId=18",
      parent: "policy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
];
